export const LEARNING_INSTRUMENT_STORAGE_KEY = "steelmora_learning_instrument";
export const LEARNING_INSTRUMENTS = ["piano", "guitar", "bass"];

export const normalizeLearningInstrument = (value) =>
  LEARNING_INSTRUMENTS.includes(value) ? value : "piano";

export const readLearningInstrumentPreference = () => {
  if (typeof window === "undefined") return "piano";
  return normalizeLearningInstrument(window.localStorage.getItem(LEARNING_INSTRUMENT_STORAGE_KEY));
};

export const writeLearningInstrumentPreference = (value) => {
  const instrument = normalizeLearningInstrument(value);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(LEARNING_INSTRUMENT_STORAGE_KEY, instrument);
  }
  return instrument;
};
